import { FetchBaseQueryMeta } from '@reduxjs/toolkit/query'

import { ModelWithPagination } from '@types'

export const transformResponseWithPagination = <OutputType>(
  res: OutputType,
  meta: FetchBaseQueryMeta
): ModelWithPagination<OutputType> => {
  return {
    data: res,
    totalCount: Number(meta?.response?.headers.get('x-page-total-pages')),
    totalCountElements: Number(meta?.response?.headers.get('x-page-total-elements')),
    currentPage: Number(meta?.response?.headers.get('x-page-current')),
    pageSize: Number(meta?.response?.headers.get('x-page-size')),
  }
}
